export function secondsToTimestamp(seconds) {
	const hours = Math.floor(seconds/3600);
	seconds = seconds % 3600;

	const minutes = Math.floor(seconds/60);
	seconds = Math.floor(seconds % 60);

	return (hours ? hours.pad(2)+':' : '') + minutes.pad(2) + ':' + seconds.pad(2)
}